module.exports = __webpack_public_path__ + "static/img/active7.1ae281f5.png";